export default "__VITE_ASSET__CnNPnpqg__"